import React from 'react'

import * as Yup from 'yup'
import { BasicForm, InputPercentage} from '../../../../core/components/form'
import { FieldArray } from 'formik'
import { Divider } from 'antd'

import { usePutAgreementForm, useFetchAgreement } from '../../../../hooks/manager/client'
import { useHistory, useParams } from 'react-router-dom'

import Loader from '../../../../components/loader'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../core/utils/form'

import mapValues from 'lodash/mapValues'

const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 }
}

const ValidationSchema = Yup.object().shape({
  agreement: Yup.lazy((obj) =>
    Yup.object(
      mapValues(obj, (value, key) => {
        return Yup.number().typeError('Must be a number.').required('Cannot be blank.')
      })
    )
  )
})

const Formulario = () => {
  const { id, catlogId } = useParams()
  const { data, isLoading, isError } = useFetchAgreement(id, catlogId)
  const update = usePutAgreementForm(id, catlogId)
  const history = useHistory()

  function handleSubmit (values, bag) {
    const form = { ...values }

    update.mutate(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        onPressBack()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const onPressBack = () => history.goBack()

  if (isLoading) {
    return (<Loader loading={isLoading} />)
  }

  if (isError) {
    return (<>Error</>)
  }

  if (!data || !data.catlog) {
    return null
  }

  const { catlog } = data
  const agreement = {}
  if (data && data.catlog.values) {
    data.catlog.values.map((i) =>
      Object.defineProperty(agreement, i.id, {
        value: 0,
        writable: true,
        enumerable: true,
        configurable: true
      })
    )
  }

  data.agreement.forEach((ca) => {
    agreement[ca.catlogValue.id] = ca.percent
  })

  const initialValues = {
    agreement
  }

  return (
    <BasicForm
      onPressBack={onPressBack}
      titulo='Agreement'
      subtitulo={catlog.name}
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={handleSubmit}
      render={({ errors, touched }) => (
        <>
          <Divider orientation='left' plain>
            {' '}
            General Fields
          </Divider>
          <FieldArray name='agreement'>
            <>
              {data.catlog.values.map((i) => {
                const e = errors.agreement ? errors.agreement : undefined
                const t = touched.agreement ? touched.agreement : undefined
                return (
                  <InputPercentage
                    name={`agreement.${i.id}`}
                    key={i.id}
                    label={i.name}
                    errors={e ? e[i.id] : undefined}
                    touched={t ? t[i.id] : undefined}
                    placeholder=''
                    layout='horizontal'
                    formItemLayout={formItemLayout}
                    required
                  />
                )
              })}
            </>
          </FieldArray>
          <Divider />
        </>
      )}
    />
  )
}

export default Formulario
